import Service from '@ember/service';
import ENV from 'bullitt-time-results/config/environment';

export default class AjaxService extends Service {
	get host() {
		return ENV.resultsBackendProtocol+"://"+ENV.resultsBackendHost+":"+ENV.resultsBackendPort+(ENV.resultsBackendNamespace ? "/"+ENV.resultsBackendNamespace : "");
	}

	request(url, options = {}) {
		const fullUrl = url.startsWith('http') ? url : `${this.host}${url}`;
		return fetch(fullUrl, options).then(response => {
			if (!response.ok) {
				throw new Error(`HTTP ${response.status}: ${response.statusText}`);
			}
			return response.json();
		});
	}
}